/**Import react section */
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import propTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { useForm } from 'react-hook-form'
/**import resources styles */
import iconFailureDoor from '../../../resources/images/failureWarranty/door.svg'
import { panelLateralServicesStyles } from '../../../resources/styles/PanelLateralServicesStyles'
/** Material UI import section */
import { Fab, Typography, DialogContent, Chip, Drawer, Grid, DialogActions } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Clear'
import EditIcon from '@material-ui/icons/Edit'
import SaveIcon from '@material-ui/icons/Save'
import ReactSelectAvatar from '../../common/ReactSelectAvatar'

/**Import styles section */
import { getOptionsReactSelect, getOptionsPreferential } from '../../../store/helpers/FilterHelper'
import { getUsersOptionsByRole } from '../../../store/helpers/UserHelper'
import { toSafeObject } from '../../../store/helpers/StateHelper'
import { IMBERA_TECHNICIAN, DISPATCHER, SERVICE_PROVIDER_TECHNICIAN } from '../../../resources/RolesEnum'
/**Import components section */
import ButtonConfirm from '../../common/Buttons/ButtonConfirm'
import AvatarCustomSize from '../../common/AvatarCustomSizes'
import withImmutablePropsToJS from 'with-immutable-props-to-js'
import { getPreferentServiceProviders } from '../../../store/serviceproviders/serviceProvidersActions'

const EditAssignmentsPanel = (props) => {
	const { onCloseButtonClick, onSetPasswordDialogConfiguration, isSaving } = props
	const { register, errors, control, handleSubmit } = useForm()

	let match = useRouteMatch()
	const serie = match.params.serie
	// const [serviceModel, setServiceModel] = useState(null)
	const [assignementModel, setAssignementModel] = useState({
		dispatcher: null,
		techAssigned: null,
		serviceProvider: null,
		serviceProviderTechAssigned: null
	})

	const dispatch = useDispatch()

	// useEffect(() => {
	// 	setServiceModel(props.service)
	// }, [props.service])

	useEffect(() => {
		if (props.service) {
			let dispatcher = {}
			if (props.service.Dispatcher) {
				dispatcher.label = props.service.Dispatcher.UserName
				dispatcher.value = props.service.Dispatcher.UserName
			}
			let techAssigned = {}
			if (props.service.TechAssigned) {
				techAssigned.label = props.service.TechAssigned.UserName
				techAssigned.value = props.service.TechAssigned.UserName
			}
			let serviceProvider = {}
			if (props.service.ServiceProvider) {
				serviceProvider.label = props.service.ServiceProvider.Code
				serviceProvider.value = props.service.ServiceProvider.Code
			}
			let serviceProviderTechAssigned = {}
			if (props.service.ServiceProviderTechAssigned) {
				serviceProviderTechAssigned.label = props.service.ServiceProviderTechAssigned.UserName
				serviceProviderTechAssigned.value = props.service.ServiceProviderTechAssigned.UserName
			}
			setAssignementModel({
				dispatcher: dispatcher,
				techAssigned: techAssigned,
				serviceProvider: serviceProvider,
				serviceProviderTechAssigned: serviceProviderTechAssigned
			})
		}
	}, [props.service])

	/** Invoke preferent providers for assignment */
	useEffect(() => {
		if (props.service) {
			dispatch(getPreferentServiceProviders(props.service.Address.state, props.service.Address.postal_code))
		}
	}, [dispatch, props.service])

	/**Get option from store redux */
	const internalUsers = useSelector((state) => toSafeObject(state.users.get('internalUsers')))
	const allServiceProviders = useSelector((state) => toSafeObject(state.serviceProviders.get('serviceProviders')))
	const providerUsers = useSelector((state) => toSafeObject(state.serviceProviders.get('providerUsers')))
	const preferentServiceProviders = useSelector((state) => state.serviceProviders.get('preferentServiceProviders'))

	/**Map the options to show in the selector */
	let seviceProviderOptions = getOptionsReactSelect(allServiceProviders)
	let preferentProviderOption = getOptionsPreferential(preferentServiceProviders)
	let onDispatchersOptions = getUsersOptionsByRole(DISPATCHER, internalUsers, false)
	let technicianOptions = getUsersOptionsByRole(IMBERA_TECHNICIAN, internalUsers, false)
	let onTechProvidersOptions = getUsersOptionsByRole(SERVICE_PROVIDER_TECHNICIAN, providerUsers, false)

	/** Invoke when select property change*/
	const onSelectChange = (name, option) => {
		setAssignementModel({
			...assignementModel,
			[name]: option
		})
	}

	const assignedService = () => {
		if (onSetPasswordDialogConfiguration) {
			onSetPasswordDialogConfiguration(props.service, assignementModel)
		}
	}

	return (
		<LateralPanel onClose={onCloseButtonClick}>
			<PanelHeader
				onCloseButtonClick={onCloseButtonClick}
				isModeSaved={true}
				// onSaveButtonClick={onSaveButtonClick}
				title={'UPDATE ASSIGNMENT'}
				ticket={props.service ? props.service.Ticket : ''}
				serie={serie}
			/>
			<DialogContent>
				<Grid container>
					<Grid item xs={12}>
						<ReactSelectAvatar
							id='dispatcher'
							name='dispatcher'
							placeholder={'DISPATCHER'}
							formatOptionLabel={formatOptionLabel}
							options={onDispatchersOptions}
							autoFocus
							onChange={onSelectChange}
							value={
								assignementModel && assignementModel.dispatcher && !!assignementModel.dispatcher.value
									? onDispatchersOptions.find((x) => x.value === assignementModel.dispatcher.value)
									: null
							}
							register={
								assignementModel && assignementModel && !!assignementModel.dispatcher
									? register({ name: 'dispatcher' }, { required: { value: false } })
									: register({ name: 'dispatcher' }, { required: { value: true, message: 'The dispatcher is required' } })
							}
							errors={errors}
							control={control}
							// isDisabled={!isAuthorizadoForEditedData}
						/>
					</Grid>
					<Grid item xs={12}>
						<ReactSelectAvatar
							id='techAssigned'
							name='techAssigned'
							placeholder={'TECHNICIAN'}
							options={technicianOptions}
							onChange={onSelectChange}
							formatOptionLabel={formatOptionLabel}
							value={
								assignementModel && assignementModel.techAssigned && !!assignementModel.techAssigned.value
									? technicianOptions.find((x) => x.value === assignementModel.techAssigned.value)
									: null
							}
							register={
								assignementModel && assignementModel && !!assignementModel.techAssigned
									? register({ name: 'techAssigned' }, { required: { value: false } })
									: register({ name: 'techAssigned' }, { required: { value: true, message: 'The technician is required' } })
							}
							errors={errors}
							control={control}
							// isDisabled={!isAuthorizadoForEditedData}
						/>
					</Grid>
					<Grid item xs={12}>
						<Typography
							color='primary'
							// className={classes.title}
						>
							{'SERVICE PROVIDER'}
						</Typography>
						<ReactSelectAvatar
							id='serviceProvider'
							name='serviceProvider'
							placeholder={'SERVICE PROVIDER'}
							options={seviceProviderOptions}
							onChange={onSelectChange}
							formatOptionLabel={formatOptionLabel}
							value={
								assignementModel && assignementModel.serviceProvider && !!assignementModel.serviceProvider.value
									? seviceProviderOptions.find((x) => x.value === assignementModel.serviceProvider.value)
									: null
							}
							register={
								assignementModel && assignementModel && !!assignementModel.serviceProvider
									? register({ name: 'serviceProvider' }, { required: { value: false } })
									: register(
											{ name: 'serviceProvider' },
											{ required: { value: true, message: 'The service provider is required' } }
									  )
							}
							errors={errors}
							control={control}
							// isDisabled={!isAuthorizadoForEditedData}
						/>
					</Grid>
					{false && (
						<Grid item xs={12}>
							<Typography
							// className={classes.title}
							>
								{'PREFERRED SERVICE PROVIDER'}
							</Typography>
							<ReactSelectAvatar
								id='prefrentServiceProvider'
								name='serviceProvider'
								placeholder={'PREFERRED SERVICE PROVIDER'}
								options={preferentProviderOption}
								onChange={onSelectChange}
								formatOptionLabel={formatOptionLabel}
								register={
									assignementModel && assignementModel && !!assignementModel.serviceProvider
										? register({ name: 'serviceProvider' }, { required: { value: false } })
										: register(
												{ name: 'serviceProvider' },
												{ required: { value: true, message: 'The service provider is required' } }
										  )
								}
								errors={errors}
								control={control}
								// isDisabled={!isAuthorizadoForEditedData || !(preferentProviderOption.length > 0)}
							/>
						</Grid>
					)}
					<Grid item xs={12}>
						<Typography
							// className={classes.title}
							color='primary'
						>
							{'SERVICE PROVIDER TECHNICIAN'}
						</Typography>
						<ReactSelectAvatar
							id='serviceProviderTechAssigned'
							name='serviceProviderTechAssigned'
							placeholder={'TECHNICIAN PROVIDER'}
							formatOptionLabel={formatOptionLabel}
							options={onTechProvidersOptions}
							autoFocus
							onChange={onSelectChange}
							value={
								assignementModel &&
								assignementModel.serviceProviderTechAssigned &&
								!!assignementModel.serviceProviderTechAssigned.value
									? onTechProvidersOptions.find((x) => x.value === assignementModel.serviceProviderTechAssigned.value)
									: null
							}
							register={
								assignementModel && !!assignementModel.serviceProviderTechAssigned
									? register({ name: 'serviceProviderTechAssigned' }, { required: { value: false } })
									: register(
											{ name: 'serviceProviderTechAssigned' },
											{ required: { value: false, message: 'The serviceProviderTechAssigned is required' } }
									  )
							}
							errors={errors}
							control={control}
							// isDisabled={!isAuthorizadoForEditedData}
						/>
					</Grid>
					<Grid item xs={12}>
						<DialogActions>
							<ButtonConfirm isSaving={isSaving} onSavedClick={handleSubmit(assignedService)} title='CONFIRM' />
						</DialogActions>
					</Grid>
				</Grid>
				{/* <Select
					id={'is-status'}
					placeholder={getPlaceholder()}
					name='status'
					autoFocus
					options={
						serviceModel ? serviceModel.AvailableOperations : null
					}
					styles={colourSelectorStyles}
					formatOptionLabel={formatOptionLabel}
					onChange={(value, action) => {
						onSelectChange(action.name, value)
					}}
				/>
				<br />
				<br />
				{GetComponentByStatus(
					changeStatusModel ? changeStatusModel.status.value : null
				)} */}
			</DialogContent>
		</LateralPanel>
	)
}

EditAssignmentsPanel.props = {
	/**open and close lateral panel config*/
	onCloseButtonClick: propTypes.func,
	/**Determinate if is saving data in the back end */
	isSavingService: propTypes.bool.isRequired,
	/**Asigned service to dipatcher, service provider and tech assigned in the service */
	onAssignementService: propTypes.func,
	/**open modal for confirm the canceled service operation */
	onSetPasswordDialogConfiguration: propTypes.func,
	/**Asigned on tech from service provider, in the service */
	onAssignementTechServiceProvider: propTypes.func
}
EditAssignmentsPanel.defaultProps = {
	isSavingService: false,
	onCloseButtonClick: () => console.warn('Callback [onCloseButtonClick] no defined'),
	onAssignementService: () => console.warn('Callback [onAssignementService] no defined'),
	onSetPasswordDialogConfiguration: () => console.warn('Callback [onSetPasswordDialogConfiguration] no defined'),
	onAssignementTechServiceProvider: () => console.warn('Callback [onAssignementTechServiceProvider] no defined')
}

const PanelHeader = (props) => {
	const { title } = props
	const { onCloseButtonClick, onSaveButtonClick, onEditButtonClick, isModeSaved, canBeSaved, isSaving, ticket, serie } = props
	const classes = panelLateralServicesStyles()

	return (
		<div className={classes.panelHeader}>
			<div className={classes.containerHeader}>
				<div className={classes.containerIcon}>
					<Fab size='medium' className={classes.faultWarrantyIconSelected} disabled={true}>
						<img src={iconFailureDoor} alt='warranty-icon' className={classes.faultWarrantyIcon} />
					</Fab>
				</div>
				<div className={classes.containerText}>
					<Typography gutterBottom variant='subtitle1' className={classes.title}>
						{title || ''}
					</Typography>
					<Typography gutterBottom variant='subtitle2' className={classes.subTitle}>{`TICKET: ${ticket || ''}`}</Typography>
					{(serie !== '-' || !serie === 'null') && (
						<Typography gutterBottom variant='subtitle2' className={classes.subTitle}>{`SERIE: ${serie || ''}`}</Typography>
					)}
				</div>
			</div>
			<div className={classes.grow} />
			{(!!onEditButtonClick || !!onSaveButtonClick) && (
				<Fab
					disabled={(isModeSaved ? !canBeSaved : false) || isSaving}
					className={isModeSaved ? classes.buttonSaved : classes.buttonEdit}
					onClick={isModeSaved ? onSaveButtonClick : onEditButtonClick}
				>
					{isModeSaved ? <SaveIcon /> : <EditIcon />}
				</Fab>
			)}
			{!!onCloseButtonClick && (
				<Fab className={classes.buttonClose} onClick={onCloseButtonClick}>
					<DeleteIcon />
				</Fab>
			)}
		</div>
	)
}
PanelHeader.propTypes = {
	/**
	 * Determine if is saving
	 */
	isSaving: propTypes.bool,
	/**
	 * Determine if is mode saved
	 */
	isModeSaved: propTypes.bool,
	/**
	 * On change button saved
	 */
	onSaveButtonClick: propTypes.func,
	/**
	 * On change button edit
	 */
	onEditButtonClick: propTypes.func
}

const LateralPanel = (props) => {
	const { onClose, children } = props

	const classes = panelEditUseStyles()

	return (
		<Drawer anchor='right' open={props.open} onClose={onClose}>
			<div className={classes.drawerContent} tabIndex={0}>
				{children}
			</div>
		</Drawer>
	)
}
LateralPanel.propTypes = {
	open: propTypes.bool.isRequired
}
LateralPanel.defaultProps = {
	open: true
}

const formatOptionLabel = ({ value, label, avatarUrl, isAvatarFromIdentity }) => (
	<div>
		<Chip
			id={value}
			size='small'
			avatar={<AvatarCustomSize avatarUrl={avatarUrl} name={label} isAvatarFromIdentity={isAvatarFromIdentity} />}
			label={label}
			clickable
			style={{ color: 'white', background: '#5357DC' }}
		/>
	</div>
)

export const panelEditUseStyles = makeStyles((theme) => ({
	tabs: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.common.white
	},
	titleContainer: {
		display: 'grid',
		gridTemplateRows: 'auto',
		gridTemplateColumns: '1fr 1fr'
	},
	titleLeftContent: {
		gridColumnStart: 1,
		gridColumnEnd: 1,
		gridRow: 1,
		paddingRight: '20px',
		paddingLeft: '20px',
		paddingTop: '10px'
	},
	titleRightContent: {
		gridColumnStart: 2,
		gridColumnEnd: 2,
		gridRow: 1,
		paddingRight: '30px',
		paddingTop: '10px'
	},
	editTab: {
		padding: '20px'
	},
	drawerContent: {
		width: '620px',
		height: '100vh',
		display: 'grid',
		gridTemplateRows: 'auto 1fr',
		overflowX: 'hidden',
		overflowY: 'hidden'
	},
	carrierHeader: {
		padding: '5px',
		display: 'grid',
		gridTemplateRows: 'auto',
		gridTemplateColumns: '50px 150px 150px 1fr'
	},
	carrierContent: {
		display: 'grid',
		gridTemplateRows: 'auto',
		gridTemplateColumns: '150px 150px 1fr'
	},
	cell1: {
		gridColumnStart: 1,
		gridColumnEnd: 1,
		gridRow: 1,
		color: theme.palette.text.primary,
		paddingRight: '5px'
	},
	cell2: {
		gridColumnStart: 2,
		gridColumnEnd: 2,
		gridRow: 1,
		color: theme.palette.text.primary
	},
	cell3: {
		gridColumnStart: 3,
		gridColumnEnd: 3,
		gridRow: 1,
		color: theme.palette.text.primary
	},
	cell4: {
		gridColumnStart: 4,
		gridColumnEnd: 4,
		gridRow: 1,
		color: theme.palette.text.primary
	},
	cell5: {
		gridColumnStart: 5,
		gridColumnEnd: 5,
		gridRow: 1,
		color: theme.palette.text.primary
	},
	carrierHeaderGrid: {
		display: 'grid',
		gridTemplateRows: 'auto',
		gridTemplateColumns: '350px 1fr'
	},
	headerLeft: {
		gridColumnStart: 1,
		gridColumnEnd: 1,
		gridRow: 1,
		padding: '5px'
	},
	headerRight: {
		gridColumnStart: 2,
		gridColumnEnd: 2,
		gridRow: 1,
		padding: '5px'
	},
	titleBold: {
		fontWeight: 'bold'
	},
	titleRight: {
		marginLeft: '3px'
	},
	flex: {
		display: 'flex'
	},
	stepper: {
		alignSelf: 'stretch',
		marginTop: '-8px'
	},
	stepLabel: {
		fontSize: '10px'
	},
	containerLineTime: {
		maxHeight: `calc(100vh - ${520}px)`,
		overflowY: 'auto'
	},
	fileImport: {
		marginRight: '5px',
		marginBottom: '-5px',
		display: 'flex',
		justifyContent: 'flex-end'
	}
}))

export default withImmutablePropsToJS(EditAssignmentsPanel)
